'use client';

import * as React from 'react';
import { NextUIProvider } from '@nextui-org/system';
import { useRouter } from 'next/navigation';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ThemeProviderProps } from 'next-themes/dist/types';
import { useAuthContext } from '@/providers/AuthProvider';

interface ProvidersProps {
  children: React.ReactNode;
  themeProps?: ThemeProviderProps;
}

export function Providers({ children, themeProps }: ProvidersProps) {
  const router = useRouter();

  const { isAuthLoaded } = useAuthContext();

  return (
    <NextUIProvider locale="en-GB" navigate={router.push}>
      <NextThemesProvider {...themeProps}>
        {isAuthLoaded ? children : null}
      </NextThemesProvider>
    </NextUIProvider>
  );
}
